<template>
  <div>
    <div id="amapStation1" v-if="!showInit" style="z-index: 99999999;display: block;height: 100vh;"></div>
  
  <div class="gis-main gis-default" id="showmap">
    
    <div style="display: flex">
      <div class="layer-control top-tool-select"  @contextmenu.prevent="handlePaste($event)">
        <!-- <div :class="['layer-show']" @click="layerShow = !layerShow">
          <img :class="[{ unfold: !layerShow }]" src="../../assets/gis/tool/toll-left.png" />
        </div> -->
        <layer-manage v-show="layerShow" ref="layerManage" class="layer" />
        <!-- <div :class="['layer-show']" @click="layerShow = !layerShow">
          <img :class="[{ unfold: !layerShow }]" src="../../assets/gis/tool/toll-left.png" />
        </div> -->
      </div>
      <div class="view">
        <div class="top-tool top-tool-select" :style="topWidth&&gis?'margin-left: 270px;':'margin-left: 79px;'" @contextmenu.prevent="handlePaste($event)">
          <topTool ref="topTool" />
          <searchTool ref="searchTool" />
         
        </div>
        
        <div class="top-tool-right top-tool-select" @click="fullScreen">
          <span
            ><img
              src="../../assets/gis/tool/top.png"
              style="height:65px;margin-top:-4px;margin-right:-7px"
          /></span>
        </div>
        <div ref="amap"  :class="topWidth&&gis?'map-size':'map-size1'">
           
           
          <div id="amapStation">
            <layer-wms ref="layerWms" :layer-name="layerName" />
            <zoom ref="zoom" />
          </div>
        </div>
        <toolbar ref="Toolbar" :props-position="propsPosition" :bottom-position="bottomPosition" />
        <toolInfo ref="toolInfo" />
        <mark-info ref="markInfo"></mark-info>
        <editVector ref="editVector"></editVector>
        <edit-feature ref="editFeature"></edit-feature>
        <rightTool
          ref="rightTool"
          :legend-name="'overView'"
          :query="false"
          :layer-tree="true"
          :home-query="true"
          @closeDraw="closeDraw"
          @draw="draw"
          @settingsItem="settingsItem"
        />
        <bottom :display-list="displayList" :pipe-display-list="pipeDisplayList" />
      </div>
    </div>
    <dialog-display
      ref="dialogDisplay"
      :display-settings="displaySettings"
      @confirm="onConfirm"
    ></dialog-display>
    <query-info ref="queryInfo"></query-info>
    <station-info ref="stationInfo"></station-info>
    <div
      v-if="isEdit && drawTipmouse && drawType != 'rule'"
      ref="drawTipmouse"
      class="drawTipmouse"
    >
      {{ drawTipmouse }}
    </div>
    <div v-if="isEdit && drawType == 'rule'" ref="drawTipmouse" class="drawTipmouse">
      <span v-if="ruleM != 0">
        总长：<span style="color:red">{{ ruleM }}</span
        >米<br />{{ drawTipmouse }}
      </span>
      <span v-else>{{ tipMessege }}</span>
    </div>
  </div>
</div>
</template>

<script>
import '@/assets/gis/iconFont/iconfont.css'
import '@/assets/gis/iconFont/iconfont.js'
//import { loadMixin } from './load/amapLoad' //有地图的总入口都要混入
import { intMixin } from './load/amapInit'
import editVector from './tool/layer/editVector'
import zoom from './tool/question/zoom' //层级控制器
import layerWms from './tool/layer/layerWms' //瓦片
import bottom from './tool/layer/bottom'
import Toolbar from './tool/leftTool/Toolbar'
import rightTool from './tool/rightTool/index'
import searchTool from './tool/searchTool/index'
import toolInfo from './tool/layer/toolInfo'
import markInfo from './tool/layer/markInfo'
import editFeature from './tool/layer/editFeature'
import dialogDisplay from './dialog/display'
import layerManage from './layerManage/index'
import topTool from './tool/topTool/index'
import SetBase from './apis/setBase'
import queryInfo from './tool/layer/queryInfo'
import stationInfo from './tool/layer/stationInfo'
import { commonLayer, initFilter, constantDict } from './utils/dict.js'
import { formatLocation } from './utils/geoTool.js'
import pl from '@/assets/gis/pl.png'
import './style/skin.scss'
import { getPixel } from '../Gis/utils/geoTool'
import { serverMap } from '../Gis/utils/dict'
import Header from '../../components/layout/Header.vue'
export default {
  name: 'Index',
  components: {
    zoom,
    layerWms,
    bottom,
    Toolbar,
    rightTool,
    toolInfo,
    dialogDisplay,
    layerManage,
    topTool,
    markInfo,
    editFeature,
    queryInfo,
    stationInfo,
    editVector,
    searchTool,
    Header
},
  mixins: [intMixin], //有地图的总入口都要混入
  data() {
    return {
      HeaderBool:true,
      drawTipmouse: '',
      layerName: commonLayer['pressure'],
      propsPosition: 280, //组件边距
      bottomPosition: 40,
      searchPosition: 0.1,
      displaySettings: null,
      displayList: [],
      isEdit: false,
      isSelectNode: false,
      layerShow: true,
      pipeDisplayList: [],
      editTool: null,
      equipmentTool: null,
      dragState: true,
      loadStateSet: 0,
      toolIndex: 0,
      queryVector: false, //根据层级判断是否开启 默认关闭
      queryVectorGeo: [], //要吸附的数据
      queryVectorObj: null, //点位对象
      queryFeatrue: null, //吸附好的值
      queryLayer: '', //要查询的图层
      queryType: '',
      ruleObj: [],
      ruleM: '0',
      cmpList: [],
      manageCmpList: [],
      gis: true,
      oldQueryFeatrue:null,
      positionNew:{},
      FullScreenBool:true,
      topWidth:true ,
      isClick:true,
      showInit:false,
      amapCss:'amapCss'
    }
  },
  computed: {},
  watch: {
    loadStateSet(val) {
      console.log(this.loadStateSet)
      if (this.loadStateSet == 3) {
        this.setlayerInit()
      }
    },
    queryType(val) {
      this.setDrawPoint(val)
    }
  },

  mounted() {
    
     XE.ready().then(this.startup);
    this.layerName = commonLayer['pressure']
    this.setStorInit()
    this.findSetting()
  },
  methods: {
    startup() {
      var earth;
    var bgImagery;
            // earth = new XE.Earth('earthContainer');
            earth = new XE.Earth('amapStation1', {
                // 这里设置Viewer的配置，和new Viewer(container, options)中的options一致
                homeButton: true,
                timeline: true,
            });

            earth.sceneTree.root = {
                "children": [
                    {
                        "czmObject": {
                          "enabled": false,
                            "name": "默认离线影像",
                            "xbsjType": "Imagery",
                            "xbsjImageryProvider": {
                                "createTileMapServiceImageryProvider": {
                                    "url": XE.HTML.cesiumDir + 'Assets/Textures/NaturalEarthII',
                                    "fileExtension": 'jpg',
                                },
                                "type": "createTileMapServiceImageryProvider"
                            }
                        }
                    },
                ]
            };

            const scene = earth.czm.scene;

            Cesium.xbsjRotateEarth(scene, 26910000, 0.5);
            scene.xbsjEarthRotatingSpeed = Math.PI / 2;
            console.log(earth
            
            
            
            
            )
            setTimeout(()=>{
            earth.camera.flyTo([115.9173576 * Math.PI / 180, 36.8554955 * Math.PI / 180, 352.85])
           
               setTimeout(()=>{
                  this.showInit = true
                  earth = earth && earth.destroy();
                  var childObj = document.getElementById("showmap")
                  childObj.style.animation='fadeOut 3s'  
                },3000)
                
             },2000)
            
        },
    handlePaste(event){
      event.preventDefault();
      return false
    },
    clearQuery() {
      if (this.queryVectorObj) {
        this.map.remove(this.queryVectorObj)
        this.queryVectorObj = null
      }
    },
    setDrawPoint(val) {
      if (val) {
        this.getBoundsFeat(this.queryLayer)
        let activeToolItem = this.$refs.topTool.activeToolItem
        let image = pl
        switch (activeToolItem) {
          case 'node': {
            image = require('./image/tool-node.png')
            break
          }
          case 'monitoring': {
            image = require('./image/tool-monitoring.png')
            break
          }
          case 'valve': {
            image = require('./image/tool-valve.png')
            break
          }
          case 'userSta': {
            image = require('./image/tool-userSta.png')
            break
          }
          case 'station': {
            image = require('./image/tool-station.png')
            break
          }
          case 'warn': {
            image = require('./image/tool-warn.png')
            break
          }
          case 'camera': {
            image = require('./image/tool-camera.png')
            break
          }
        }
        if (!this.queryVectorObj) {
          this.queryVectorObj = new AMap.Marker({
            icon: new AMap.Icon({ image: image, imageOffset: new AMap.Pixel(0, 0) }),
            anchor: 'center',
            position: [0, 0]
          })
          this.map.add(this.queryVectorObj)
        } else {
          this.queryVectorObj.setIcon(
            new AMap.Icon({ image: image, imageOffset: new AMap.Pixel(0, 0) })
          )
        }
      } else {
        if (this.queryVectorObj&&!this.$refs.topTool.activeToolItem) {
          this.map.remove(this.queryVectorObj)
          this.queryVectorObj = null
        }
      }
    },
    mouseHover(e) {
      let disX = e.pixel.x
      let disY = e.pixel.y
      if (this.$refs.drawTipmouse) {
        this.$refs.drawTipmouse.style.top = disY + 20 + 'px'
        this.$refs.drawTipmouse.style.left = disX + 0+ 'px'
      }
    },
    setStorInit() {
      this.$store.commit('gis/legendSelectChange', initFilter)
    },
    setlayerInit() {
      this.$store.commit('gis/legendSelectChange', initFilter)
      this.$eventBus.$emit('setFilter')
      // this.$store.commit('gis/legendSelectChange', initFilter) //默认选中图层
      // let filter =
      //   'node_type2 in (' + initFilter.toString() + ',' + constantDict.guanxian.dictCode + ')'
      // this.$refs.layerWms.init(filter, this.layerName)
    },
    settingsItem(val) {
      this.$refs[val].open()
    },
    async findSetting() {
      try {
        let { data } = await SetBase.findSetting()
        this.onConfirm(data, 1, true)
        this.loadStateSet = this.loadStateSet + 1
      } catch (error) {}
    },
    async onConfirm(val, type, need) {
      this.$store.commit('gis/isLegendSelectChange', [])
      if (!commonLayer[val]) {
        val = '40000'
      }
      this.layerName = commonLayer[val]

      if (this.loadStateSet > 2 && !need) {
        this.$eventBus.$emit('setFilter')
      }
      if (this.displaySettings === val) return
      if (!type) {
        try {
          await SetBase.setting({ value: val })
        } catch (error) {}
      }
      this.displayList = []
      this.pipeDisplayList = []
      this.displaySettings = val
      if (val == 'texture') {
        try {
          let res = await SetBase.getList({ pidDictCode: 1000240001 })
          let { data } = await SetBase.getList({ pidDictCode: 1000240002 })
           let data1 = await SetBase.getList({ pidDictCode: 1000240003 })
          res.data.forEach(el => {
            el.select = true
          })
          data.forEach(el => {
            el.select = true
          })
           data1.data.forEach(el => {
            el.select = true
          })
          data.push({
              "id": 1,
              "pidDictCode": "",
              "dictName": "默认",
              "dictCode": "0",
              "showName": "默认",
              "colour": "#ff0084",
              "sort": 1,
              "select": true
          })
          this.pipeDisplayList = [res.data, data,data1.data]
        } catch (error) {}
      } else {
        try {
          let res = await SetBase.getList({ pidDictCode: val })
          let retData = res.data
          retData.forEach(element => {
            element.select = true
          })
          console.log(retData)
          retData.push({
              "id": 1,
              "pidDictCode": "",
              "dictName": "默认",
              "dictCode": "0",
              "showName": "默认",
              "colour": "#ff0084",
              "sort": 1,
              "select": true
          })
          this.displayList = retData
        } catch (error) {}
      }
    },
    
    initMap() {
      let that = this
      let map = new AMap.Map('amapStation', {
        ...that.mapConfig
      })
      that.map = map
      map.addControl(new AMap.Scale())

      that.map.on('complete', function() {
        that.$refs.zoom.init()
        //  that.getMark()
        that.drawEnd()
        that.$refs.topTool.endToolDraw()
        that.loadStateSet = that.loadStateSet + 1
         that.map.setDefaultCursor('default')
        that.$refs.rightTool.xyzTileLayer = new AMap.TileLayer({
          zIndex:3,
          dataZooms:[16,19],
          zooms:[16,19],
          getTileUrl: function(x , y, z){
            var url = '/tms_lq/'+z+'/'+x+'/'+y+'.png';
            return url;
          }
        });    
        that.map.add(that.$refs.rightTool.xyzTileLayer)
        that.$refs.rightTool.Satellite = new AMap.TileLayer.Satellite()
        that.map.add(that.$refs.rightTool.Satellite)
        that.getMarkStation(1)
      })

      that.map.on('mousemove', e => {
        let lnglat = e.lnglat
        this.positionNew = lnglat
        if (that.isEdit) {
          that.mouseHover(e)
        }
        that.AdAnalysis(lnglat, e)

        if (that.drawType == 'rule') {
          let length = that.ruleObj.length
          if (length > 0) {
            let l = AMap.GeometryUtil.distanceOfLine([...that.ruleObj, lnglat])
            that.ruleM = l.toFixed(1)
            that.mouseHover(e)
          }
        }
      })
      that.map.on('moveend', e => {
        that.getBoundsFeat(that.queryLayer)
      })
      that.map.on('click', e => {
        //  that.$refs.editVector.getVectorQuery(e.lnglat)
        // 工具栏编辑状态
        console.log(that.isEdit)
        if (that.isEdit) {
          if (that.$refs.topTool.activeToolItem == 'line') {
            console.log('绘制管线')
            that.$nextTick(function() {
              let obj = that.editTool.overlays.polyline
              that.$refs.topTool.getClosestFeature(obj[obj.length - 1])
            })
          } else if (that.$refs.topTool.activeToolItem == 'drag') {
            that.$refs.editVector.getVectorQuery(e.lnglat, 'drag')
          } else if (that.$refs.topTool.activeToolItem == 'interrupt') {
            that.$refs.editVector.getVectorQuery(e.lnglat, 'interrupt')
          }
          /* } else if (that.dragState) {
          that.getVectorQuery(e.lnglat) */
        } else if (that.isSelectNode) {
          // 选取场站--进站、出站
          that.$refs.stationInfo.selectStationNode(e.lnglat)
        } else {
          // 查看编辑管线、设备
          that.$refs.editFeature.editFeature(e.lnglat)
        }

        if (that.drawType == 'rule') {
          //米
          that.ruleObj.push(e.lnglat)
        }
      })
      that.map.on('rightclick', e => {
        if (!that.isEdit) {
          that.$refs.editFeature.changeLayer(e.lnglat)
        }
      })
      // that.map.on('mousedown', e => {
      //   if (that.drawState) {
      //     //绘制提示信息
      //     that.onClick(e)
      //   }
      // })

      //工具
      that.mouseTool = new AMap.MouseTool(that.map)
      // 管线设备工具条
      that.editTool = new AMap.MouseTool(that.map)
      // 安全设备工具条
      that.equipmentTool = new AMap.MouseTool(that.map)
      //   that.getMark() 默认显示
    },
    openQuery() {
      this.$refs.Childmain.openQuery() //打开综合查询页面
    },
    AdAnalysis(lnglat, e) {
      let that = this
      if (
        that.queryVectorObj &&
        that.layerName &&
        that.$store.getters.activeOptionItem == 'adsorption'
      ) {
        let distanceP = null
        let distanceL = null
        let feature = {}
        let maxlength = 10
        let point = {}
        let line = {}
       
        that.queryVectorGeo.forEach(item => {
          if (item.geometry.type == 'Point') {
            if (
              ((item.properties.node_type2 == constantDict.jiedian.dictCode
              ||item.properties.node_type2 == constantDict.qitaguanjian.dictCode
              ||item.properties.node_type2 == constantDict.guanxiandian.dictCode
              ||item.properties.node_type2 == serverMap[1002][0].dictCode
              ||item.properties.node_type2 == constantDict.santong.dictCode
              ||item.properties.node_type2 == constantDict.gangsuzhuanhuan.dictCode
              ||item.properties.node_type2 == constantDict.bianjin.dictCode) &&
                that.layerName == commonLayer['pressure']) ||
              that.layerName != commonLayer['pressure']
            ) {
              let path = formatLocation(item.properties.location_str, 'Point')
              let l = AMap.GeometryUtil.distance(lnglat, path)
              if (!distanceP || distanceP > l) {
                distanceP = l
                item.l = l
                point = item
              }
            }
          } else {
            let path = formatLocation(item.properties.location_str, 'LineString')
            let l = AMap.GeometryUtil.distanceToLine(lnglat, path)
            if (!distanceL || distanceL > l) {
              distanceL = l
              item.l = l
              line = item
            }
          }
        })
      //  console.log(JSON.parse(JSON.stringify(point)) ,JSON.parse(JSON.stringify(line)))
        if ((point.l||point.l==0) && (line.l || line.l==0)) {
      //    console.log(111111111111)
          let  pointP = formatLocation(point.properties.location_str, 'Point')
        
           let pathP= formatLocation(line.properties.location_str, 'LineString')
           let  lineP = AMap.GeometryUtil.closestOnLine(lnglat, pathP)
         

           let d=getPixel(that.map,lineP,pointP)
//console.log(d)
          // let d = point.l - line.l
          if (d > 5 && line) {
            feature = line
          } else {
            feature = point
          }
        } else {
         // console.log(point)
          feature = point.geometry ? point : line
        }
        if (feature.properties) {
          let bounds = that.map.getBounds()
          let northEast = bounds.northEast //东北角 southWest
          let southWest = bounds.southWest
          let pixel = e.pixel
          let px = Math.sqrt(pixel.x * pixel.x + pixel.y * pixel.y)
          let pointObj = null
          if (feature.geometry.type == 'Point') {
            pointObj = formatLocation(feature.properties.location_str, 'Point')
          } else {
            let path = formatLocation(feature.properties.location_str, 'LineString')
            pointObj = AMap.GeometryUtil.closestOnLine(lnglat, path)
          }
         // let m = Math.round(AMap.GeometryUtil.distance([southWest.lon, northEast.lat], pointObj))
          let m = AMap.GeometryUtil.distance([southWest.KL, northEast.kT], e.lnglat)

          let m2 = AMap.GeometryUtil.distance(lnglat, pointObj)
     //     console.log(pointObj,feature)
        //  console.log(m2,m,px,m2 * (px / m))
          //距离小于规定像素
          if (m2 * (px / m) < maxlength) {
            that.queryVectorObj.setPosition(pointObj)
            feature.pointObj = pointObj
            that.queryFeatrue = feature
            that.oldQueryFeatrue = feature
          } else {
            that.queryVectorObj.setPosition(lnglat)
            that.queryFeatrue = null
          }
        } else {
          that.queryVectorObj.setPosition(lnglat)
          that.queryFeatrue = null
        }
      } else if (that.queryVectorObj && that.queryType) {
        that.queryVectorObj.setPosition(lnglat)
      }
    },
    /**
     * 全屏
     */
    fullScreen() {
      if (this.FullScreenBool) {
        var el = document.documentElement
        var rfs =
          el.requestFullScreen ||
          el.webkitRequestFullScreen ||
          el.mozRequestFullScreen ||
          el.msRequestFullScreen
        if (rfs) {
          rfs.call(el)
        } else if (typeof window.ActiveXObject !== 'undefined') {
          var wscript = new ActiveXObject('WScript.Shell')
          if (wscript != null) {
            wscript.SendKeys('{F11}')
          }
        }
      } else {
        var el = document
        var cfs =
          el.cancelFullScreen ||
          el.webkitCancelFullScreen ||
          el.mozCancelFullScreen ||
          el.exitFullScreen
        if (cfs) {
          cfs.call(el)
        } else if (typeof window.ActiveXObject !== 'undefined') {
          var wscript = new ActiveXObject('WScript.Shell')
          if (wscript != null) {
            wscript.SendKeys('{F11}')
          }
        }
      }
      this.FullScreenBool = !this.FullScreenBool
    }
  }
}
</script>
<style lang="scss">
 @keyframes fadeOut {
    0% {
    opacity: 0;
    }
    100% {
      opacity: 1;
    }
 }
</style>
<style lang="scss" scoped>
.gis-main {
  position: relative;
}

::v-deep .amap-ranging-label {
  background: var(--background-color-skin);
  border: 1px solid var(--font-color-b1);
}

.layer-control {
  // float: left;
  background: var(--background-color-skin);
  height: calc(100vh - 150px);
  color: var(--font-color-f1);
  position: relative;

  .layer {
    width: 250px;
  }

  .layer-show {
    cursor: pointer;
    width: 10px;
    height: 52px;
    position: absolute;
    // right: -16px;
    top: 45%;
    z-index: 9;
    background: #23344f;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--border-color-skin);
    border-left: none;

    img {
      width: 10px;

      &.unfold {
        transform: rotate(180deg);
      }
    }

    // border-radius: 3px;
  }
}

.top-tool {
  position: absolute;
  z-index: 9;
  margin-left: 270px;
  margin-top: 10px;
  height: 10px;
}
.top-tool-right {
  position: absolute;
  z-index: 9;
  right: 1px;
  margin-top: 10px;
  height: 10px;
}

.map-size {
  text-align: center;

  width: 100%;
  height: calc(100vh - 73px);
  
  ::v-deep .amap-scalecontrol {
    background: none !important;
    left: 270px !important;
    bottom: 10px !important;
    transition: left 0.5s;
  }
}
.map-size1 {
  text-align: center;

  width: 100%;
  height: calc(100vh - 73px);
  
  ::v-deep .amap-scalecontrol {
    background: none !important;
    left: 10px !important;
    bottom: 10px !important;
    transition: left 0.5s;
  }
}

#amapStation {
  width: 100%;
  height: 100%;
 
}
.amapCss{
   transition: opacity 4s;
   opacity: 0;
}
.amapCss1 {
    opacity: 1;
}

.view {
  position: relative;
  flex: 1;
  color: var(--font-color-f1);
  // margin-left: 250px;
  width: auto;
}


::v-deep .drawDel {
  color: #01d8ff;
  font-size: 18px;
}

::v-deep.deleteNode {
  content: url(./image/rule-remove.png);
}
.drawTipmouse {
  position: absolute;
  top: -100px;
  left: 0;
  z-index: 8;
  background: var(--background-color-skin);
  border-radius: 5px;
  color: var(--font-color-f1);
  padding: 5px 10px;
  white-space: nowrap;
}
.top-tool-select{ 
 -webkit-touch-callout:none; /*系统默认菜单被禁用*/ 
 -webkit-user-select:none; /*webkit浏览器*/ 
 -khtml-user-select:none; /*早期浏览器*/ 
 -moz-user-select:none;/*火狐*/ 
 -ms-user-select:none; /*IE10*/ 
 user-select:none; 
} 
input{ 
 -webkit-user-select:auto; /*webkit浏览器*/  
}
textarea{
 -webkit-user-select:auto; /*webkit浏览器*/
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 10s
}
.fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
    opacity: 0
}
</style>
